// client/src/hooks/useTabVisible.js
import { useContext, useEffect, useState } from 'react';
import TabVisibilityContext from '../context/TabVisibilityContext';

/**
 * True when this page is actually on screen — its tab is the active one AND the
 * browser window itself is visible. Background tabs stay mounted (that's the
 * point), so anything with an ongoing cost should ask before doing work.
 */
export default function useTabVisible() {
  const paneVisible = useContext(TabVisibilityContext);
  const [documentVisible, setDocumentVisible] = useState(() =>
    typeof document === 'undefined' ? true : document.visibilityState === 'visible'
  );

  useEffect(() => {
    const onChange = () => setDocumentVisible(document.visibilityState === 'visible');
    document.addEventListener('visibilitychange', onChange);
    return () => document.removeEventListener('visibilitychange', onChange);
  }, []);

  return paneVisible && documentVisible;
}
